import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentReference} from "../../angular/models/agentReference.model";

export class AgentAssistantModeCtrl implements IController {

  agent: AgentModel;

  public activeTooltip: boolean;

  constructor() {
  }

  $onInit() {
    this.activeTooltip = false;
  }

  getUserFromReference(agentReference:AgentReference) {
    return {
      firstName: agentReference.firstName,
      lastName: agentReference.lastName,
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentAssistantMode', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-assistant-mode.html').default,
    controller: AgentAssistantModeCtrl
  });
